import { Dispatch } from 'redux';
import PAGES_TYPES from './types';
import API_ROUTES from 'services/apiRoutes';
import { oathApi } from 'services/oathApi';

export const getPagesAPI = async (urlPartner: string) =>
  oathApi.get(API_ROUTES.GET_DONATE_PAGE(urlPartner));

export const getPages =
  () =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(PAGES_TYPES.pagesStart());

    try {
      const response = await oathApi.get(API_ROUTES.GET_PAGES);
      dispatch(PAGES_TYPES.pagesSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(PAGES_TYPES.pagesError(error.message));
      return Promise.reject(error);
    }
  };
